module.exports = __webpack_public_path__ + "static/profile-kevin-mortlock-d7eb811a3a4a9b8d2f0bd8ca6c913bf4.jpg";